import React, {createContext, useEffect, useState} from 'react';
import Loader from "../components/Loader";
import introspectionQueryResultData from '../service/introspectionQueryResults';
const SchemaContext = createContext();

function SchemaProvider({children}) {
    console.log('[SchemaContext] Using static schema information');
    const [isClient, setIsClient] = useState(false);
    
    // Ustaw flagę po pierwszym renderowaniu po stronie klienta
    useEffect(() => {
        setIsClient(true);
    }, []);
    
    // Używaj statycznej definicji schematu zamiast pobierać ją dynamicznie
    const schema = introspectionQueryResultData.__schema;

    const getAttribute = (field) => {
        if (!schema || !schema.queryType || !schema.queryType.fields || field === "attribute_set_id") {
            return "";
        }
        
        try {
            // Get products
            const products = schema.queryType.fields.find(({name}) => name === "products");
            if (!products || !products.args) return "";
            
            const filter = products.args.find(({name}) => name === "filter");
            if (!filter || !filter.type || !filter.type.inputFields) {
                return "";
            }
            
            // Determine the type
            const fieldData = filter.type.inputFields.find(({name}) => name === field) || {};
            const {type} = fieldData;

            // So that it doesn't yell
            if (!type) {
                return "";
            }
            
            // Get the name
            return type.name || "";
        } catch (error) {
            console.error("Error in getAttribute:", error);
            return "";
        }
    };

    const getFilterType = (field) => {
        // Hardcoded mapping jako fallback
        const knownRangeFields = ['width', 'height', 'price', 'size', 'weight', 'capacity'];
        const knownEqualFields = ['brand', 'color', 'material', 'category_id', 'manufacturer'];
        const knownMatchFields = ['name', 'description', 'sku'];
        
        if (knownRangeFields.includes(field.toLowerCase())) {
            console.log(`[Filter] ${field} -> FilterRangeTypeInput (hardcoded)`);
            return 'FilterRangeTypeInput';
        }
        
        if (knownMatchFields.includes(field.toLowerCase())) {
            console.log(`[Filter] ${field} -> FilterMatchTypeInput (hardcoded)`);
            return 'FilterMatchTypeInput';
        }
        
        if (!schema || !schema.queryType || !schema.queryType.fields || field === "attribute_set_id") {
            // Fallback na FilterEqualTypeInput dla nieznanych pól
            console.log(`[Filter] ${field} -> FilterEqualTypeInput (fallback)`);
            return "FilterEqualTypeInput";
        }
        
        try {
            // Get products
            const products = schema.queryType.fields.find(({name}) => name === "products");
            if (!products || !products.args) {
                console.log(`[Filter] ${field} -> FilterEqualTypeInput (no products)`);
                return "FilterEqualTypeInput";
            }

            // Extract the filter
            const filter = products.args.find(({name}) => name === "filter");
            if (!filter || !filter.type || !filter.type.inputFields) {
                console.log(`[Filter] ${field} -> FilterEqualTypeInput (no filter)`);
                return "FilterEqualTypeInput";
            }

            // Determine the type
            const fieldData = filter.type.inputFields.find(({name}) => name === field) || {};
            const {type} = fieldData;

            // So that it doesn't yell
            if (!type) {
                console.log(`[Filter] ${field} -> FilterEqualTypeInput (no type)`);
                return "FilterEqualTypeInput";
            }
            
            // Get the name
            const filterType = type.name || "FilterEqualTypeInput";
            console.log(`[Filter] ${field} -> ${filterType} (from schema)`);
            return filterType;
        } catch (error) {
            console.error("Error in getFilterType:", error);
            return "FilterEqualTypeInput";
        }
    }

    return (
        <SchemaContext.Provider value={{getFilterType, getAttribute, schema}} >
            {children}
        </SchemaContext.Provider>
    );
}

export { SchemaProvider, SchemaContext };
